import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const formatDateTime24 = (value, locale = "it-IT") => {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleString(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const DateTimeDisplay = () => {
  const { i18n, t } = useTranslation();
  const [date, setDate] = useState(new Date());
  const [lang, setLang] = useState(i18n.resolvedLanguage || 'en');

  useEffect(() => {
    const handleLangChange = (lng) => setLang(lng);
    setLang(i18n.resolvedLanguage || i18n.language);
    i18n.on('languageChanged', handleLangChange);
    return () => i18n.off('languageChanged', handleLangChange);
  }, [i18n]);

  useEffect(() => {
    const timer = setInterval(() => setDate(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatDate = (d) => {
    const hours = String(d.getHours()).padStart(2, '0');
    const mins = String(d.getMinutes()).padStart(2, '0');
    const time = `${hours}:${mins}`;

    if (lang === 'sq') {
      // Manual Albanian — uses your existing month keys in i18n.js
      const monthKeys = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'];
      const month = t(`month.${monthKeys[d.getMonth()]}`);
      return `${d.getDate()} ${month} ${d.getFullYear()} - ${time}`;
    }

    const localeMap = { en: 'en-US', it: 'it-IT' };
    const locale = localeMap[lang] || 'en-US';
    return `${d.toLocaleDateString(locale, { year: "numeric", month: "long", day: "numeric" })} - ${d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', hour12: false })}`;
  };

  return (
    <Typography
      sx={{
        fontFamily: '"Pontano Sans", "Helvetica Neue"',
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        flex: "1 1 auto",
      }}
      fontSize={{ xs: "11px", sm: "14px" }}
      paddingLeft={{ xs: "8px", sm: "16px" }}
      paddingRight={{ xs: "4px", sm: "16px" }}
      paddingTop={{ xs: "0px", sm: "8px" }}
      paddingBottom={{ xs: "0px", sm: "8px" }}
    >
      {formatDate(date)}
    </Typography>
  );
};

export default DateTimeDisplay;
